// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dataStatistic[data-v-23a53fc5]{display:grid;grid-gap:16px;overflow-y:hidden;overflow-x:hidden;grid-template:repeat(2,1fr)/repeat(2,1fr);height:100%;box-sizing:border-box}.dataStatistic .item[data-v-23a53fc5]{border:1px solid #3ab0e3;width:560px;height:312px;box-sizing:border-box}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
